// extracted by mini-css-extract-plugin
export var burgerBtn = "BurgerButton-module--burger-btn--3Pto4";
export var bar1 = "BurgerButton-module--bar1--2Vqrg";
export var bar2 = "BurgerButton-module--bar2--3Za2T";
export var bar3 = "BurgerButton-module--bar3--VJDTl";
export var clicked = "BurgerButton-module--clicked--51nBU";